import WarningReportItem from './warning-item';
import WarningItemGraph from './warning-item-graph';
import { WarningsReportItemRow } from './types';

import cn from './styles.module.css';

const WarningItemRow = ({
  setShowDetalisation,
  maxCount,
  warningItem,
  title,
  filteredWarningItem,
  organizationDetails,
  monitoringRules,
  withIcon,
  monitoringRuleId,
}: WarningsReportItemRow) => (
  <div className={cn.warningItemRow}>
    <WarningReportItem
      title={title}
      selectedWarningsReportCount={filteredWarningItem}
      warningReportsCount={warningItem}
      setShowDetalisation={setShowDetalisation}
      organizationDetails={organizationDetails}
      monitoringRules={monitoringRules}
      withIcon={withIcon}
      monitoringRuleId={monitoringRuleId}
    />
    <WarningItemGraph
      maxCount={maxCount}
      warningReportsCount={warningItem as number}
      selectedWarningsReportCount={filteredWarningItem}
      organizationDetails={organizationDetails}
    />
  </div>
);

export default WarningItemRow;
